/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationRemoteSessionIssuersList } from "../funcs/organizationRemoteSessionIssuersList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListOrganizationRemoteSessionIssuersRequest,
  ListOrganizationRemoteSessionIssuersResponse,
  ListOrganizationRemoteSessionIssuersSecurity,
  Tier,
} from "../models/operations/listorganizationremotesessionissuers.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type OrganizationRemoteSessionIssuersQueryData =
  ListOrganizationRemoteSessionIssuersResponse;

export type OrganizationRemoteSessionIssuersInfiniteQueryData = PageIterator<
  ListOrganizationRemoteSessionIssuersResponse,
  { cursor: string }
>;

export type OrganizationRemoteSessionIssuersPageParams = PageIterator<
  ListOrganizationRemoteSessionIssuersResponse,
  { cursor: string }
>["~next"];

export function prefetchOrganizationRemoteSessionIssuers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListOrganizationRemoteSessionIssuersRequest | undefined,
  security?: ListOrganizationRemoteSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationRemoteSessionIssuersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchOrganizationRemoteSessionIssuersInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListOrganizationRemoteSessionIssuersRequest | undefined,
  security?: ListOrganizationRemoteSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildOrganizationRemoteSessionIssuersInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as OrganizationRemoteSessionIssuersPageParams,
    getNextPageParam: (
      previousPage: OrganizationRemoteSessionIssuersInfiniteQueryData,
    ) => previousPage["~next"],
  });
}

export function buildOrganizationRemoteSessionIssuersQuery(
  client$: GramCore,
  request?: ListOrganizationRemoteSessionIssuersRequest | undefined,
  security?: ListOrganizationRemoteSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationRemoteSessionIssuersQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionIssuers({
      cursor: request?.cursor,
      limit: request?.limit,
      tier: request?.tier,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
    }),
    queryFn: async function organizationRemoteSessionIssuersQueryFn(
      ctx,
    ): Promise<OrganizationRemoteSessionIssuersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationRemoteSessionIssuersList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildOrganizationRemoteSessionIssuersInfiniteQuery(
  client$: GramCore,
  request?: ListOrganizationRemoteSessionIssuersRequest | undefined,
  security?: ListOrganizationRemoteSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<
      QueryKey,
      OrganizationRemoteSessionIssuersPageParams
    >,
  ) => Promise<OrganizationRemoteSessionIssuersInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionIssuersInfinite({
      cursor: request?.cursor,
      limit: request?.limit,
      tier: request?.tier,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
    }),
    queryFn: async function organizationRemoteSessionIssuersQuery(
      ctx,
    ): Promise<OrganizationRemoteSessionIssuersInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(
          organizationRemoteSessionIssuersList(
            client$,
            request,
            security,
            mergedOptions,
          ),
        );
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(
        organizationRemoteSessionIssuersList(
          client$,
          {
            ...request!,
            cursor: ctx.pageParam.cursor,
          },
          security,
          mergedOptions,
        ),
      );
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyOrganizationRemoteSessionIssuers(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    tier?: Tier | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessionIssuers",
    "list",
    parameters,
  ];
}

export function queryKeyOrganizationRemoteSessionIssuersInfinite(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    tier?: Tier | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessionIssuers",
    "list",
    "infinite",
    parameters,
  ];
}
